import React, { useState } from "react";
import SubHeader from "../../menu/SubHeader";
import { ISelectOption } from "../forms/util";
import { TakeFivePageSelector } from "./TakeFivePageSelector";
import { TakeFiveSidebar } from "./TakeFiveSidebar";
import './TakeFive.css'

interface TakeFivePageProps {
    selectedPage: ISelectOption,
    children?: React.ReactNode
}

export const TakeFivePage = (props: TakeFivePageProps) => {
    const [currentSelection] = useState(props.selectedPage);

    return (
        <>
            <div className="take-five">
                <div className="take-five-header-bg"></div>
                <div className="narrow-container">
                    <SubHeader />
                    <div className="take-five-page">
                        <TakeFivePageSelector selectedPage={currentSelection} />

                        <div className="row">
                            <div className="de-wide col-3">
                                <TakeFiveSidebar selectedPage={currentSelection} />
                            </div>
                            <div className="col">
                                <React.Fragment>{props.children}</React.Fragment>
                            </div>
                        </div>

                        <div className="take-five-footer"></div>
                    </div>
                </div>
            </div>
        </>
    );
};